import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function CountdownTimer({ targetTime }) {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = new Date(targetTime).getTime();
      const difference = target - now;

      if (difference <= 0) {
        return 'Sending soon...';
      }

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes} minutes`;
    };

    // Calculate immediately
    setTimeLeft(calculateTimeLeft());

    // Update every minute
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);

    return () => clearInterval(interval);
  }, [targetTime]);

  return <span className="countdown-timer text-muted">{timeLeft}</span>;
}

CountdownTimer.propTypes = {
  targetTime: PropTypes.string.isRequired,
};

export default CountdownTimer;
